<template>
    <v-dialog-old ref="addTagsFromListDialog" id="addTagsFromList" :overflow="true">
        <main id="mainCtrl" v-cloak>
            <header>
                <button style="margin-top:4px;" @click.prevent="collapseAll">Свернуть все</button>
                <button style="margin-top:4px;" @click.prevent="expandAll">Развернуть все</button>
            </header>
            <form style="height: calc(90vh - 105px); overflow-x: hidden; overflow-y: scroll;">
                <div>
                    <services-tree v-for="tree in servicesTree"
                                   :tree="tree"
                                   :expanded="expanded"
                                   :key="tree.id"
                                   @expand="expand"
                                   @collapse="collapse"
                                   @leafChecked="selectALeaf"/>
                </div>
            </form>
        </main>
        <template v-slot:footer>
            <v-loading-component>
                <template slot-scope="{ loadingClass }">
                    <div style="position: fixed; bottom: 8vh; left: calc(50vw - 49px);">
                        <button :class="[{green: true}, loadingClass]" @click.prevent="submit">Подтвердить</button>
                    </div>
                </template>
            </v-loading-component>
        </template>
    </v-dialog-old>
</template>

<script>
    import ServicesTree from "../../common/Structurals/Trees/ServicesTree"
    export default {
        components: { ServicesTree },
        props: {
            services: {
                type: Array,
            },
            servicesTree: {
                type: Array,
            },
        },
        data: () => ({
            expanded: [],
            selected: [],
            selectedFull: [],
        }),
        methods: {
            selectALeaf(service) {
                if (!this.selected.includes(service.id) && service.checked) {
                    this.selected.push(service.id);
                    this.selectedFull.push(service);
                }
                if (this.selected.includes(service.id) && !service.checked) {
                    this.selected = this.selected.filter(id => id !== service.id);
                    this.selectedFull = this.selectedFull.filter(item => item.id !== service.id);
                }
            },
            collapseAll() {
                this.expanded = []
            },
            expandAll() {
                this.servicesTree.forEach(line => {
                    if (! this.expanded.includes(line.id)) {
                        this.expanded.push(line.id)
                    }
                })
            },
            collapse(id) {
                this.expanded = this.expanded.filter(item => item !== id)
            },
            expand(id) {
                if (!this.expanded.includes(id)) {
                    this.expanded.push(id)
                }
            },
            submit() {
                this.$emit('servicesChanged', this.selectedFull);
                this.$refs.addTagsFromListDialog.hide();
            },
        },
    }
</script>
